import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function broadcastReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isCreatingBroadcast: true };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isCreatingBroadcast: false };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isCreatingBroadcast: false };

        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingBroadcast: true };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingBroadcast: false };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingBroadcast: false };

        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingBroadcastMessage: true, broadcast_messages: [] };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingBroadcastMessage: false, broadcast_messages: action.data.data, broadcast_messages_count: action.data.count };
        case getNamedAction(ACTION_NAMES.BROADCAST, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingBroadcastMessage: false, broadcast_messages: [], broadcast_messages_count: 0 };

        case getNamedAction(ACTION_NAMES.IGNORE_BROADCAST, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingBroadcast: true };
        case getNamedAction(ACTION_NAMES.IGNORE_BROADCAST, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingBroadcast: false };
        case getNamedAction(ACTION_NAMES.IGNORE_BROADCAST, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingBroadcast: false };

        case getNamedAction(ACTION_NAMES.BROADCAST_CREATED_BY_USERS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCreatedByUsers: true, created_by_users: [] };
        case getNamedAction(ACTION_NAMES.BROADCAST_CREATED_BY_USERS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCreatedByUsers: false, created_by_users: action.data };
        case getNamedAction(ACTION_NAMES.BROADCAST_CREATED_BY_USERS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCreatedByUsers: false, created_by_users: [] };

        case getNamedAction(ACTION_NAMES.NEW_BROADCAST_MESSAGE, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingNewBroadcastMessages: true };
        case getNamedAction(ACTION_NAMES.NEW_BROADCAST_MESSAGE, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingNewBroadcastMessages: false, new_broadcast_message: action.data?.broadcast };
        case getNamedAction(ACTION_NAMES.NEW_BROADCAST_MESSAGE, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingNewBroadcastMessages: false, new_broadcast_message: {} };

        default:
            return state;
    }
}


export default broadcastReducer;
